import React, { useContext } from 'react';
import { Grid, TextField, Button, FormControlLabel, Checkbox } from '@mui/material';
import { channelsContext } from 'views/Admin/Channels/ChannelsContext';
import { SearchOutlined as SearchIcon, AddOutlined as AddIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';


let Filters = () => {
    let service = useContext(channelsContext);


    return (
        <>
            <Grid item xs={2}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Search"
                    value={service.search.fullText}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        fullText: e.target.value
                    })}
                />
            </Grid>
            <Grid item xs={2}>
                <FormControlLabel
                    label="Show disabled"
                    value={service.search.showDisabled}
                    checked={service.search.showDisabled}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        showDisabled: e.target.checked
                    })}
                    control={<Checkbox style={{ padding: '0px 8px' }} />}
                />
            </Grid>
            <Grid item xs>
                <Button
                    type="submit"
                    variant="outlined"
                    aria-label="search"
                    onClick={() => service.doSearch(service.search)}
                >
                    <SearchIcon />
                </Button>
            </Grid>
            <Grid item>
                <Button
                    variant="contained"
                    color='inherit'
                    component={Link}
                    to={'/admin/channel/addnew'}
                >
                    <AddIcon />&nbsp;Add New
                </Button>
            </Grid>
        </>
    );
}

export default Filters;